<template>
  <div class="live-score-brand">
    <div class="img-bg" @click="clickShow">
      <img src="@/assets/images/score_bg.png" class="bg-style">
      <div class="score-border">
        <div class="top">
          <div class="top-left"><span>{{sectionName}}</span></div>
          <div class="top-right overflow-text">{{match && match.chineseName}}</div>
        </div>
        <div class="bottom">
          <div class="bottom-font overflow-text" :style="{border: homeBorderColor}">{{game.homeTeam && game.homeTeam.name}}</div>
          <div class="bottom-center" v-if="game.homeScore > -1 || game.awayScore > -1">{{game.homeScore}}-{{game.awayScore}}</div>
          <div class="bottom-center" v-else>VS</div>
          <div class="bottom-font overflow-text" :style="{border: awayBorderColor}">{{game.awayTeam && game.awayTeam.name}}</div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click="clickShow">
      <div>这里是最佳计分条位置</div>
      <img src="@/assets/images/line_score_border.png">
    </div>
  </div>
</template>

<script>
import { bkGetGameDetail, bkGetGameLiveInfo } from '@/api/match'
import { ImageFormat } from '@/utils'
function add0(m) { return m < 10 ? '0' + m : m }
export default {
  name: 'LiveScore',
  data() {
    return {
      query: '',
      maskShow: false,
      game: {},
      match: {},
      homeBorderColor: '',
      awayBorderColor: '',
      sectionName: '',
      gameId: '',
      gameClockSeconds: '00:00',
      onTimeoutClock: null,
      onTimeoutRequest: null
    }
  },
  created() {

  },
  mounted() {
    this.maskShow = true
    this.query = this.$route.query
    this.gameId = this.query.gameId // 719496, 719498
    this.getGameDetails()
    this.getGameDetailScore()
    this.getGameLiveInfo()
  },
  methods: {
    // api
    getGameLiveInfo() {
      let params = {
        gameId: this.gameId // 2907
      }
      bkGetGameLiveInfo(params).then(response => {
        if (response) {
          const data = response.data
          const gameClock = data.gameClock
          clearTimeout(this.onTimeoutClock)
          if (gameClock) {
            const now = new Date().getTime() / 1000
            let gameClockSeconds = gameClock.enclosedSeconds
            if (gameClock.lastActivateUtcSeconds && gameClock.lastActivateUtcSeconds > 0) {
              gameClockSeconds = gameClock.enclosedSeconds + (parseInt(now, 10) - gameClock.lastActivateUtcSeconds)
            }
            this.gameClockSeconds = this.formatMediaTime(gameClockSeconds)
            if (gameClock.status !== 'readyToRun') {
              if (gameClock.isOverTime || gameClock.currentSection > 4) {
                this.sectionName = '加时赛'
              } else if (gameClock.currentSection) {
                this.sectionName = `第${gameClock.currentSection}节`
              }
            }
            if (gameClock.status === 'running') {
              // timer
              this.onTimeoutClock = setInterval(() => {
                gameClockSeconds += 1
                this.gameClockSeconds = this.formatMediaTime(gameClockSeconds)
              }, 1000)
              this.$once('hook:beforeDestroy', () => {
                clearInterval(this.onTimeoutClock)
              })
            }
          }
        }
      })
    },
    getGameDetailScore() {
      let params = {
        gameId: this.gameId // 2907
      }
      bkGetGameDetail(params).then(response => {
        if (response) {
          const data = response.data
          this.game = data.game
        }
      })
    },
    getGameDetails() {
      let params = {
        gameId: this.gameId // 719496
      }
      bkGetGameDetail(params).then(response => {
        if (response) {
          const data = response.data
          const game = data.game
          this.awayBorderColor = this.getColorStyle(game.awayClothesColor)
          this.homeBorderColor = this.getColorStyle(game.homeClothesColor)
          this.match = data.match
          if (this.match) {
            // this.match.poster = ImageFormat.imageView(this.match.poster, 375, 211, 1)
          }
          this.loopLiveState() // 轮询初始化，便于状态更新
        }
      })
    },
    getColorStyle (colorCode) {
      let colorStyle = ''
      if (colorCode === '1') {
        colorStyle = '#ffffff'
      } else if (colorCode === '2') {
        colorStyle = '#247cc0'
      } else if (colorCode === '3') {
        colorStyle = '#e74135'
      } else if (colorCode === '4') {
        colorStyle = '#ffc600'
      } else if (colorCode === '5') {
        colorStyle = '#0eb769'
      } else if (colorCode === '6') {
        colorStyle = '#694c92'
      } else if (colorCode === '7') {
        colorStyle = '#ed7000'
      } else if (colorCode === '8') {
        colorStyle = '#232323'
      } else if (colorCode === '25') {
        colorStyle = '#fc4481'
      } else if (colorCode === '26') {
        colorStyle = '#65c5e4'
      } else if (colorCode === '27') {
        colorStyle = '#e2fa16'
      }
      colorStyle = `6px solid ${colorStyle}`
      return colorStyle
    },
    loopLiveState() {
      clearTimeout(this.onTimeoutRequest)
      this.onTimeoutRequest = setInterval(() => {
        this.getGameDetailScore()
        this.getGameLiveInfo()
      }, 5000)
      this.$once('hook:beforeDestroy', () => {
        clearTimeout(this.onTimeoutRequest)
      })
    },
    clickShow () {
      this.maskShow = false
    },
    imageView(hash, w, h, mode, format) {
      return ImageFormat.imageView(hash, w, h, mode, format)
    },
    formatMediaTime (duration) {
      let min = Math.floor(duration / 60)
      let second = duration - min * 60
      min = add0(min)
      second = add0(second)
      return min + ':' + second
    }
  }
}
</script>

<style lang="scss">
  .live-score-brand {
    width: 1280px !important;
    margin: 0 auto;
    position: relative;
    left: -380px;
    top: 0;
    .overflow-text{
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .img-bg{
      width: 100%;
      height: 720px;
      position: relative;
      overflow: hidden;
      .bg-style{
        width: 100%;
        /*max-width: 480px;*/
        height: 720px;
        position: relative;
        top: 0;
        left: 0;
      }
      .score-border{
        width: 759px;
        height: 118px;
        position: absolute;
        bottom: 5px;
        right: 5px;
        color: #ffffff;
        text-align: center;
        z-index: 999;
        .top{
          width: 759px;
          height: 59px;
          display: flex;
          justify-content: flex-start;
          .top-left{
            width: 165px;
            font-size: 30px;
            background-image: url("../../assets/images/state_score.png");
            background-size: cover;
            background-color: #ffffff;
            border: 0;
            span{
              line-height: 59px;
            }
          }
          .top-right{
            width: 594px;
            height: 59px;
            line-height: 59px;
            background-color: #ffffff;
            font-size: 30px;
            color: #142430;
          }
        }
        .bottom{
          height: 59px;
          line-height: 59px;
          display: flex;
          .bottom-font{
            width: 294px;
            background-color:#142430;
            font-size: 30px;
            border-top: 0 !important;
            border-left: 0 !important;
            border-right: 0 !important;
          }
          .border-left{
            border-bottom:2px solid #A745BD;
          }
          .bottom-center{
            width: 171px;
            background-color: #CE302C;
            font-size: 43px;
          }
          .border-right{
            border-bottom:2px solid #ECD57C;
          }
        }
      }
    }
    /* 遮罩层*/
    .mask{
      width: 100%;
      height: 720px;
      background-color:#000000;
      opacity: 0.6;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      img{
        width: 235px;
        height: 187px;
        margin-top: 385px;
        margin-left: 26px;
      }
      div{
        z-index: 99;
        color: #ffffff;
        padding-top: 360px;
        padding-left: 355px;
        font-size: 36px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/live-score/index.vue